let osConnection = {};

var generalConnector;
var net = window.require('net');
var client;

var slideshow;//var used in wsh
var statePPT = "NoKnown"; //var used in wsh
let lastPpts = [];//var used in wsh
let isWSH = true;//var used in wsh

export default function FlipwitSlideConnectorWindows(connectorInstance) {
  generalConnector = connectorInstance;
  return osConnection;
}

osConnection.getTempPath = function() {
  const remote = window.require('electron').remote;
  //
  var imagePathToglea = remote.app.getPath('userData');
  
  return imagePathToglea;
}

osConnection.comparePpts = function( newPpts ){
  //console.log('last ' + lastPpts.length + " " + newPpts.length)
  if (lastPpts.length != newPpts.length)
        return false;

    for (var i = 0, l=lastPpts.length; i < l; i++) {
        if (lastPpts[i] != newPpts[i]) { 
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;   
        }           
    }       
    return true;
}

osConnection.decodePptsName = function( newPpts ){
  for (var i = 0, l=newPpts.length; i < l; i++) {
     newPpts[i] = decodeURIComponent( newPpts[i]);           
  }       
}

osConnection.stateExecuted = function( state ){
 // osConnection.decodePptsName(state.response.ppts);
 //console.log('state', state)
  if( state.response.error ){
    console.log('STATE ERROR MSG ', state.response.error);
    return;
  }


  if( ! osConnection.comparePpts( state.response.ppts ) ){
    console.log('pone uno nuevo')
    lastPpts = state.response.ppts;
    generalConnector.pptsOpen(state.response.ppts);  
  }

  osConnection.setStatePPT( state.response.state );

  if( statePPT == "viewing" ){
    //console.log("state.response " + state.response.position);
    generalConnector.setSlidePosition(state.response.position,true);
  }
  
}

//posibles estados: viewing, editing, closed, done
osConnection.setStatePPT = function( state ){
  if( statePPT != state ){
    console.log("estado: " + state);
    let lastState = statePPT;
    statePPT = state;

    switch( statePPT ){
      case "viewing": 
            console.log("paso a viewing " + lastState)
            if( lastState == "editing" ){
              osConnection.getNotes( );        
            }
            break;

      case "closed":
      case "started":
            generalConnector.ppClosed();
         break;

      case "done":
              generalConnector.slideShowDone();
              generalConnector.hideTogleaWindow();
        break;

      case "editing":
              if( lastState == "viewing" || lastState == "done"){
                osConnection.setImagesVisible();
                generalConnector.slideShowEnds();
              }
        break;
      }
  } 
}

osConnection.setImagesVisible = function( ){
  slideshow.visibleImgs();
}

osConnection.getNotes = function( ){
  console.log('LLAME LAS MNOTAS')
  slideshow.info( osConnection.infoExecuted );
}

osConnection.infoExecuted = function( data ){
  console.log("data of info: ", data)

  generalConnector.setElectronSession();
  /*let previewsPath = data.response.previewsPath.replace(new RegExp(":", 'g'), "/");
  if( !previewsPath.startsWith("/")){
    previewsPath = previewsPath.substring( previewsPath.indexOf("/") );
  }*/
  generalConnector.setResolutionData( data.response.resX, data.response.resY, data.response.resW, data.response.resH)
  generalConnector.setPreviewsPath( data.response.previewsPath);
  generalConnector.setSlidesImages(data.response.images); 
  generalConnector.setPPTName(data.response.name);
  generalConnector.setSlidesNotes(data.response.notes);  
  generalConnector.verifyPreviews();  //*/
  //slideshow.continueExporting( generalConnector.getCurrentExportingSlide );
}


osConnection.init = function() 
{
  if(generalConnector.isConnected()) return;

  if( isWSH ){
    var SlideShow = require("../mac/api/slideshow-api");
    slideshow = new SlideShow("powerpoint");

    slideshow.setStateCB( osConnection.stateExecuted, generalConnector.timeScriptWSH );
    slideshow.setErrorCB( generalConnector.errorData );
  }
  else{
    if(client!=null) {
      client.destroy();
      client = null;
    }

    client = new net.Socket();
    
    client.connect(11001, '127.0.0.1', function() { 
      generalConnector.setPowerPointConnected(true);
       console.log('-----------------> Connected ' + generalConnector.isConnected() + " para " + client);
    });  

    client.on('data', function(stringdata) {
         console.log('raw: ' + stringdata)
        //codigo que se hizo porque algunas veces llegaban 2 json seguidos
        //asi: '{ "command": "slideUpdated",  "slideType": "REGULAR_SLIDE", "currentSlideNumber": "1",  "data": {   "slideComments": "" }} {  "command": "notes", "previewsPath": "C:/Users/CarvajalMarin/AppData/Local/Temp/slidePreviews",  "notes": [""],  "images": [{}], "currentSlideNumber": "1",  "name": "Test 3"}';
        var data = (function(input) {
          let odd = true;
          let arrayJson = input.split(/\}\s*\{/g);

          return arrayJson.reduce(function(res, part, i) {
            if( arrayJson.length > 1 ){
               console.log('LLEGARON VARIOS COMANDOS: ' + input)
              if(odd) {
                if( i != 0){
                  part = "{" + part;
                }

                if( i != arrayJson.length - 1){
                  part += "}";
                }
              } else {
                part = "{" + part;

                if( i != arrayJson.length - 1){
                  part += "}";
                }
              }
              
              odd = !odd;
            }        
            
            res[i] = part;
            
            return res;
          }, {});
        })(""+stringdata)

        for (var command in data) {
          osConnection.processSocketData(data[command]);
        }
      
      
      //client.destroy(); // kill client after server's response
    });

    client.on('close', function() {
      //connected = false;
      generalConnector.setPowerPointConnected(false);
      if(client!=null) client.destroy(); 

      setTimeout(osConnection.init,2000);
    });  

    client.on('error', function(ex) {

      if(ex.message.includes("ECONNRESET")) {
        client.destroy();    
        client = null;  
        return;
      }

      setTimeout(osConnection.init,2000);
      client.destroy();    
    });
  }

}

osConnection.processSocketData = function(stringdata) {
  var data = {};
  try {
     console.log('Received from Socket: ' + stringdata);
    data = JSON.parse(stringdata);    
  } catch (ex) {
    console.error('ERROR ON SOCKET DATA', ex);
  }
  
  switch(data.command) {
    case "notes":
      //if ( generalConnector.isDataFromSelected() ){
        generalConnector.setElectronSession();
        generalConnector.setPreviewsPath(data.previewsPath);
        generalConnector.setSlidePosition(data.currentSlideNumber, false);
        generalConnector.setSlidesImages(data.images);  
        generalConnector.setPPTName(data.name);
        generalConnector.setSlidesNotes(data.notes);
        generalConnector.verifyPreviews();
     // }
      
      break;

    //Si se actualizo la diapositiva lee los comentarios de esta
    //Los procesa, ya que un comentario puede tener informacion interna de toglea o un comentario normal
    //del usuario para mostrar en el movil
    case "slideUpdated":
      generalConnector.setSlidePosition(data.currentSlideNumber,true);
      break;

    case "slideShowEnds":
      generalConnector.slideShowEnds();
      break;
      
    case "SlideShowDone":
      generalConnector.slideShowDone();
      generalConnector.hideTogleaWindow();
      break;
    case "windowMinimized":
    case "powerPointClosed":
      generalConnector.hideTogleaWindow();
      generalConnector.pptsOpen([]);
      break;
    case "pptsOpen":
      generalConnector.pptsOpen(data.ppts);
      break;
  }

  /*if(data.command == "imageInSlide") {
    generalConnector.setTogleaSlide( data.name, data.x, data.y, data.width, data.height, data.wslide, data.hslide, data.resX, data.resY, data.resW, data.resH );
  }*/
}

osConnection.getImageToglea = function( ){
  if(generalConnector.isConnected()) {
    var request = {command:"AskInfoFeature",infoNeeded: "imageInSlide"};
    client.write(JSON.stringify(request) + '<EOF>');
  }
}

osConnection.finishSlideshow = function() {  
  if( isWSH ){
    slideshow.stop();  
  }else{
    this.sendInteractionCommand("Finish");
  }      
} 

osConnection.startSlideshow = function(pptName) {  
  if( isWSH ){
    const remote = window.require('electron').remote;
    let countScreens = remote.app.getCountScreens();
    console.log("cantidad des creens " + countScreens);

    if( statePPT == "viewing" || statePPT == "done"){
      osConnection.getNotes();
    }
    else{
      slideshow.start( encodeURIComponent(pptName), countScreens );//as("applescripts/runPresentation")
    }
  }
  else{
    this.sendInteractionCommand("Init", pptName);    
  }
} 

osConnection.goNextSlide = function() {
  if( isWSH ){
    slideshow.next();
  }
  else{
    this.sendInteractionCommand("Next");
  }
}

osConnection.goPrevSlide = function() {
  if( isWSH ){
    slideshow.prev();
  }
  else{
    this.sendInteractionCommand("Prev");
  }
}

osConnection.insertSlide = function( path, idImage, width, height, pptName, comment ){
  if( isWSH ){
    slideshow.insertSlide( encodeURIComponent(path), idImage, width, height, encodeURIComponent(pptName), encodeURIComponent(comment) );
  }
  else{
    if(generalConnector.isConnected()) {
      var request = {command:"InsertActFeature",path: encodeURIComponent(path), id: idImage + '\r' + comment, w: width, h: height, pptName:pptName};
      var temp = JSON.stringify(request);
      temp =  temp.replace(/\\r/g, "\r")
      console.log("EL TEMP: " + temp);
      client.write( temp + '<EOF>');
    }
  }
}

osConnection.sendInteractionCommand = function(command, pptName = "") {
  if(!generalConnector.isConnected()) {
     console.log('Ignora el mensaje ' + command + ' porque no esta conectado')
    return;
  }
  else {
    if(client!=null) {
      //Ej. {"command":"InteractionFeature","interactionType":"Next"}<EOF>
      client.write(JSON.stringify(this.createInteractionCommand(command, pptName)) + '<EOF>');
    }
  }  
}

osConnection.createInteractionCommand = function(command, pptName = "") {
  return {
    command: "InteractionFeature",
    interactionType: command,
    pptName: pptName
  };
}

osConnection.activatePP = function(){
  if( isWSH ){
    console.log('activate')
    slideshow.activate();
  }
  else{
    this.sendInteractionCommand("Activate");
  }
}

osConnection.getPptsOpen = function(){
  if( isWSH ){
    generalConnector.pptsOpen( lastPpts );
  }
  else{
    if(generalConnector.isConnected()) {
      var request = {command:"AskInfoFeature",infoNeeded: "getOpenPPTs"};
      client.write(JSON.stringify(request) + '<EOF>');
    }
    else{
      generalConnector.pptsOpen([]);
    }
  }  
}

osConnection.exportSlides = function(namePPT, startedFromAuditorium){
  slideshow.exportSlides( encodeURIComponent(namePPT), this.onSlidesExported, startedFromAuditorium );
}

osConnection.onSlidesExported = function( resp ){
  generalConnector.onSlidesExported( resp );
}


// WEBPACK FOOTER //
// ./src/containers/platforms/electron/js/powerpoint/windows/FlipwitSlideConnectorWindows.js